<template>
  <div class="page-content bg-black">
    <div class="text-container">
      <h2 class="text-center">get real. california quiz.</h2>
      <div class="text-content text-content-direction">
        <div class="text-col bg-white">
          <p>It’s time to show what you know about California! Here’s how it works:</p>
          <ol class="numbered-list">
            <li v-for="item in items" :key="item" v-html="item"></li>
          </ol>
        </div>
        <div class="btn-holder">
          <a href="#" class="btn-next" @click.prevent="goToNextStep">
            <span>start the game!</span>
          </a>
        </div>
      </div>
    </div>
    <div class="logo-row-bottom">
      <div class="logo-holder">
        <img src="@/assets/images/ymi.png" width="53" height="43" alt="image description">
      </div>
      <div class="logo-holder">
        <img src="@/assets/images/got-milk.png" width="191" height="55" alt="image description">
        <p class="copy">&copy; 2024 California Milk Processor Board</p>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from "vuex";

  export default {
    name: 'Directions',
    computed: {
      ...mapGetters({
        items: 'getDirectionsItems'
      })
    },
    methods: {
      ...mapMutations({
        next: 'nextStep',
        stop: 'stop'
      }),
      goToNextStep() {
        this.next();
        this.stop('theme_music');
      }
    },
    mounted() {
      window.dispatchEvent(new Event('resize'));
    }
  }
</script>
